import { initializeAxiosBaseQuery } from '@gasbi/shared/common/utils/axiosBaseQuery';

import http from '@/utils/http';

const axiosBaseQuery = initializeAxiosBaseQuery(http);

export default axiosBaseQuery;
